manageApp = angular.module("clientApp.filters", [])

manageApp.filter "appVersion", ["version", (version) ->
  return (text) ->
    String(text).replace /\%VERSION\%/g, version
]
